exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".printing-summary .date-input {\n  line-height: normal !important;\n}\n", ""]);
